import React, { useState } from "react";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";

const TrasferPagination = ({ data, itemsPerPage }) => {
  const [currentPage, setCurrentPage] = useState(1);

  // Define the index values correctly
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  // Current items for the page
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages calculation
  const totalPages = Math.ceil(data.length / itemsPerPage);

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
<div className="w-full">
  <h2 className="font-semibold mb-6">
    {data.length > 0
      ? `Showing Results ${indexOfFirstItem + 1} to ${Math.min(
          indexOfLastItem,
          data.length
        )} of ${data.length}`
      : "No results found"}
  </h2>

  {/* Full-width list items */}
  <div className="w-full">
    {currentItems.map((item, index) => (
      <div key={index} className="w-full">{item}</div>
    ))}
  </div>

  {/* Pagination controls centered horizontally */}
  {/* <div className="flex justify-center gap-2 mt-6 w-full">
    <button
      className="w-9 h-9 border rounded-full flex justify-center items-center"
      onClick={prevPage}
      disabled={currentPage === 1}
    >
      <BsArrowLeftShort size={22} />
    </button>
    {Array.from({ length: totalPages }).map((_, index) => (
      <button
        key={index}
        onClick={() => paginate(index + 1)}
        className={
          currentPage === index + 1
            ? "active bg-primary text-white font-medium w-9 h-9 border rounded-full flex justify-center items-center"
            : "w-9 h-9 border rounded-full flex justify-center font-medium items-center"
        }
      >
        {index + 1}
      </button>
    ))}
    <button
      className="w-9 h-9 border rounded-full flex justify-center items-center"
      onClick={nextPage}
      disabled={currentPage === totalPages}
    >
      <BsArrowRightShort />
    </button>
  </div> */}
</div>

  );
};

export default TrasferPagination;
